import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {BillingAccountSummaryData} from "./billing-account-summary.data";
import {BillingSetupIntentData} from "./billing-setup-intent.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class BillingAccountService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getBillingAccount(venueId: string): Promise<BillingAccountSummaryData> {
        return firstValueFrom(this.http.get<BillingAccountSummaryData>("/fonzie/customer-instance-venue/" + venueId + "/billing-account", {headers: this.auth.getHttpHeaderOptions()}));

    }

    async createBillingAccount(venueId: string): Promise<BillingAccountSummaryData> {
        return firstValueFrom(this.http.post<BillingAccountSummaryData>("/fonzie/customer-instance-venue/" + venueId + "/billing-account", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createSetupIntent(venueId: string): Promise<BillingSetupIntentData> {
        return firstValueFrom(this.http.get<BillingSetupIntentData>("/fonzie/customer-instance-venue/" + venueId + "/create-setup-intent", {headers: this.auth.getHttpHeaderOptions()}));
    }
}
